// Composition root: a canvas driven by the Viewer controller (viewer.ts) + the HUD
// (Hud.tsx). Scene-list fetching lives here — it's independent of the renderer so the
// list shows up even while/if WebGPU init lags or fails.

import { createSignal, onCleanup, onMount } from "solid-js";
import { Hud } from "./Hud.tsx";
import { createViewer, type Scene } from "./viewer.ts";

export function App() {
  let canvas!: HTMLCanvasElement;
  const viewer = createViewer();

  const [scenes, setScenes] = createSignal<Scene[]>([]);
  const [scenesError, setScenesError] = createSignal<string | null>(null);

  onMount(() => {
    viewer.attach(canvas);
    onCleanup(() => viewer.dispose());
  });

  // Ask the Rust API what scenes it has.
  onMount(async () => {
    try {
      const res = await fetch("/api/scenes");
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = (await res.json()) as { scenes?: Scene[] };
      setScenes(data.scenes ?? []);
      setScenesError(null);
    } catch (e) {
      setScenesError(`couldn't reach server: ${e}`);
    }
  });

  return (
    <div style={{ position: "relative", height: "100%", width: "100%" }}>
      <canvas ref={canvas} class="gsplat-canvas" />
      <Hud viewer={viewer} scenes={scenes()} scenesError={scenesError()} />
    </div>
  );
}
